export default {
    floorIndex: 4
}